module.exports = __webpack_public_path__ + "img/invite_user_poster2.f0ca7c8b.png";